"use client";

import * as React from "react";
import { Link } from "lucide-react";
import { Button } from "@heroui/button";
import { notify } from "@/components/ui/toast";

export default function CopyButton({ post }) {
  const [copied, setCopied] = React.useState(false);

  return (
    <Button
      name="Copy link to clipboard"
      aria-label="Copy link to clipboard"
      variant="flat"
      color={copied ? "success" : "default"}
      onClick={() => {
        notify({
          content: `https://kejk.tech/thoughts/${post?.slug}`,
          setCopied,
        });
      }}
      startContent={
        <Link className="size-4 shrink-0 transition duration-200 ease-in-out group-hover:rotate-45" />
      }
    >
      {copied ? "Copied" : "Copy link"}
    </Button>
  );
}
